/*
 * Payment details "Download CSV": who is waiting and the review flags, never the details themselves
 * (no email, account holder, account number, IFSC, bank, branch, PAN or GSTIN). Pure; csv.test.js.
 */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { bare } from '../payouts/csv';
import { awaiting_status } from './adapters';

const PAGE = 'Payment details';
export const details_csv_name = (table) => () => csv_file_name({ page: PAGE, table });

// pending_view rows.
export const PENDING_COLUMNS = [
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Submission ID', key: 'detail_uuid' },
  { header: 'Submitted at (IST)', value: (r) => bare(r.submitted_at), kind: 'datetime' },
  {
    header: 'Submission',
    value: (r) => (r.is_change ? 'Replaces approved details' : 'First submission')
  },
  { header: 'Shared with another teacher', key: 'shared_account', kind: 'bool' },
  { header: 'Name check', value: (r) => bare(r.name_match && r.name_match.label) },
  { header: 'GST registered', key: 'gst_registered', kind: 'bool' },
  { header: 'GST rate', value: (r) => (r.gst_registered ? bare(r.gst_rate) : '') },
  { header: 'TDS rate', value: (r) => bare(r.tds_rate) }
];

// awaiting_view rows.
export const AWAITING_COLUMNS = [
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Latest payment month', value: (r) => bare(r.latest_month) },
  { header: 'Payment details', value: (r) => awaiting_status(r).label },
  { header: 'Waiting submission ID', key: 'pending_detail_uuid' },
  { header: 'Rejected submission ID', value: (r) => (r.rejection ? r.rejection.detail_uuid : '') },
  { header: 'Rejection reason', value: (r) => (r.rejection ? bare(r.rejection.reason) : '') },
  { header: 'Rejected by', value: (r) => (r.rejection ? bare(r.rejection.by) : '') },
  {
    header: 'Rejected at (IST)',
    value: (r) => (r.rejection ? bare(r.rejection.at) : ''),
    kind: 'datetime'
  }
];

// history_view rows; full UUIDs so a row can be traced.
export const HISTORY_COLUMNS = [
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Submission ID', key: 'detail_uuid' },
  { header: 'Decision', value: (r) => r.action.label },
  { header: 'Reason', key: 'reason' },
  { header: 'By', value: (r) => bare(r.by) },
  { header: 'At (IST)', value: (r) => bare(r.at), kind: 'datetime' }
];
